import loadable from '@loadable/component';
import PageLoader from '@yaydoo/react-components/lib/components/AppLoaders/PageLoader';

const Report = loadable(
  () =>
    import(
      /* webpackChunkName: "Report" */
      './report'
    ),
  {
    fallback: <PageLoader type="icon" />,
  },
);

export default Report;
